'use client'
import type { ReactNode } from 'react'
import { createContext } from 'react'
import type { CheckoutContextType } from './types'

export const CheckoutContext = createContext<CheckoutContextType | null>(null)

interface CheckoutContextProps {
  children: ReactNode
  providerProps: CheckoutContextType
}

function CheckoutContextProvider({ children, providerProps }: CheckoutContextProps) {
  return (
    <CheckoutContext.Provider value={{ ...providerProps }}>{children}</CheckoutContext.Provider>
  )
}

export default CheckoutContextProvider
